<div class="atp-actions-popup__container">
  <atp-title class="atp-actions-popup__title" [text]="data.title" [style.color]="data.titleColor"></atp-title>
  <div mat-dialog-content class="atp-actions-popup__content">
    <ng-container *ngIf="message">
      {{data.message}}
    </ng-container>
    <ng-container *ngIf="!message">
      <ul>
        <li *ngFor="let mess of messages">{{mess}}</li>
      </ul>
    </ng-container>
  </div>
  <div mat-dialog-actions class="atp-actions-popup__actions">
    <button mat-raised-button *ngIf="data.successBtnTitle" [color]="data.successBtnColor" (click)="close(true)"
      cdkFocusInitial>{{data.successBtnTitle}}</button>
    <button mat-raised-button *ngIf="data.cancelBtnTitle"
      [color]="!data.successBtnTitle ? data.successBtnColor : 'basic'"
      (click)="close(false)">{{data.cancelBtnTitle}}</button>
  </div>
</div>